<template>
  <router-view></router-view>
</template>

<script>
	export default {
		name: "commonLabel"
	}
</script>

<style scoped>

</style>
